import "./UserForm.scss";
import Spinner from "../../../components/Spinner/Spinner";
import Buttons from "../../../components/Buttons/Buttons";
import useUserForm from "./useUserForm";
import UserFormHeader from "./UserFormHeader";
import UserProfileFields from "./UserProfileFields";
import UserFormSecondaryEmails from "./UserFormSecondaryEmails";
import UserFormOtpModal from "./UserFormOtpModal";

const UserForm = () => {
  const {
    errors,
    formData,
    secondaryEmails,
    newSecondaryEmail,
    setNewSecondaryEmail,
    editingIndex,
    editingEmail,
    setEditingEmail,
    isLoading,
    otp,
    setOtp,
    otpModalRef,
    resetPassword,
    onResetPasswordClick,
    handleChange,
    handleAddSecondaryEmail,
    handleDeleteSecondaryEmail,
    handleEditSecondaryEmail,
    handleSaveEditSecondaryEmail,
    handleCancelEditSecondaryEmail,
    isFormChanged,
    handleSubmit,
    handleCancel,
    handleProfile,
    handleVerifyOtp,
    handleCancelOtp,
  } = useUserForm();

  return (
    <div className="main2">
      {isLoading && (
        <div className="loader-container">
          <div className="loader">
            <Spinner />
          </div>
        </div>
      )}
      <UserFormHeader onBack={handleProfile} />
      <div className="main2_profileform">
        <div className="main2_profileform_container">
          <div className="main2_profileform_container_section">
            <UserProfileFields
              formData={formData}
              errors={errors}
              onChange={handleChange}
              resetPassword={resetPassword}
              onResetPasswordClick={onResetPasswordClick}
            />

            <UserFormSecondaryEmails
              secondaryEmails={secondaryEmails}
              newSecondaryEmail={newSecondaryEmail}
              onNewSecondaryEmailChange={setNewSecondaryEmail}
              onAddSecondaryEmail={handleAddSecondaryEmail}
              editingIndex={editingIndex}
              editingEmail={editingEmail}
              onEditingEmailChange={setEditingEmail}
              onEditSecondaryEmail={handleEditSecondaryEmail}
              onSaveEditSecondaryEmail={handleSaveEditSecondaryEmail}
              onCancelEditSecondaryEmail={handleCancelEditSecondaryEmail}
              onDeleteSecondaryEmail={handleDeleteSecondaryEmail}
            />
          </div>
        </div>
        <div className="main2_profileform_container_buttons">
          <div className="main2_profileform_container_buttons_cont">
            <div className="main2_profileform_container_buttons_cont_sec">
              <Buttons
                text="Cancel"
                type="button"
                onClick={handleCancel}
                className="cancel-button"
                variant="secondary"
                style={{ width: "100px" }}
              />
              <Buttons
                text="Save"
                type="button"
                onClick={handleSubmit}
                className="save-button"
                variant="primary"
                disabled={!isFormChanged()}
                style={{ width: "100px" }}
              />
            </div>
          </div>
        </div>

        <UserFormOtpModal
          dialogRef={otpModalRef}
          otp={otp}
          onOtpChange={setOtp}
          onCancel={handleCancelOtp}
          onVerify={handleVerifyOtp}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default UserForm;
